var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-alert',{attrs:{"dismissible":false,"title":_vm.s__('AICatalog|A new version is available'),"primary-button-text":_vm.s__('AICatalog|Update'),"secondary-button-text":_vm.s__('AICatalog|View latest version')},on:{"primary-action":_vm.updateVersion,"secondary-action":_vm.viewLatestVersion}},[_vm._v("\n  "+_vm._s(_vm.updateMessage)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }